export default "__VITE_ASSET__Ca5YzOYp__"